export enum NotesMainCat {
    RxAnnonation = "RxAnnotation",
    RxAnnonations = "Rx Annotation",
    Patient = "Patient",
    Prescriber = "Prescriber",
    Drug = "Drug",
    Insurance = "Insurance",
    eRx = "eRx",
    Rx = "Rx",
    General = 'General',
    //Sub Categories
    CLINICAL_ALERTS = 'Clinical Alerts',
    RPH = 'RPH',
    PDMP = 'PDMP',
}

export enum NotesPopUpScreenCode {
    er = "Edit Rx",
    nr = "New Rx",
    dpv = "DPV",
    rph = "RPh Vrf",
    cn = "Create New",
    rf = "Refill",
    all = "All",
}

export enum NotesCatIdEnum {
    General = 1,
    Patient = 2,
    Prescriber = 3,
    Rx = 4,
    Drug = 5,
    Insurance = 6,
    Erx = 7,
    RxAnnotation = 8,
}